import moment from 'moment';

const CUSTOM_LOCALE = 'es-PR';
const EN_US_LOCALE = 'en-US';

export const date = (value, format = 'DD/MMM/YYYY') => {
  if (!value) return '-';
  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .format(format)
    .replace(/ 0(?:0)?/, ' ');

  const days = [
    'domingo',
    'lunes',
    'martes',
    'miércoles',
    'jueves',
    'viernes',
    'sábado',
  ];
  const months = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ];

  const currentDay = days[moment(value).day()];
  const currentMonth = months[moment(value).month()];

  result = result.replace(
    currentDay,
    currentDay.charAt(0).toUpperCase() + currentDay.slice(1)
  );
  result = result.replace(
    currentMonth,
    currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1)
  );

  return result;
};

export const datetime = (value) => {
  if (!value) return '-';
  return moment(value)
    .locale(CUSTOM_LOCALE)
    .format('DD/MMM/YYYY hh:mm a')
    .replace(/ 0(?:0)?/, ' ');
};

export const currency = (value) => {
  if (value === undefined || value === '' || value === null) return '-';
  return value.toLocaleString(EN_US_LOCALE, { minimumFractionDigits: 0 });
};

export const capitalize = (value) => {
  if (!value) return '';
  value = value.toString();

  return value
    .toLowerCase()
    .split(' ')
    .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
    .join(' ');
};

export const empty = (value) => {
  return !value ? '-' : value;
};

export const phone = (value) => {
  if (!value) return '-';

  return value
    .replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const hour = (value) => {
  if (!value) return '-';

  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .format('hh:mm a');

  return result;
};

export const price = (value) => {
  let val = (value / 1).toFixed(2);
  let formattedValue = parseFloat(Math.abs(val)).toLocaleString('en-US', {
    minimumFractionDigits: 2,
  });

  return val < 0 ? '-$' + formattedValue : '$' + formattedValue;
};

export const appointmentFormat = (value) => {
  if (value == undefined || value == '') return '-';

  return value
    .toString()
    .replace(/[^0-9]/g, '')
    .replace(/(\d{4})(\d{6})/, '$1-$2');
};
